import { style } from "@vanilla-extract/css";

import { theme } from "../../../theme/css/theme.css";
import { rem } from "@huub-web/utils/css/rem";

export const searchStyle = style({
  height: rem(42),
  width: `calc(100% - ${rem(42)} - ${theme.spacings.m})`,
});

export const searchIconStyle = style({
  marginRight: theme.spacings.xxs,
});
